#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment postOverviewPageContent on postsOverview_Entry {
    title
    description: richTextMinimal
    seo {
        ... socialFragment
    }
    showNewsletterSubscribe
}
